import * as yup from 'yup';

export const initialValues = {
  companyName: '',
  //billingContact: '',
  type: '',
  sites: [],
  banner: '',
};

export const validationSchema = yup.object().shape({
  companyName: yup.string().required('company name is required'),
  //billingContact: yup.string().required('billing contact is required'),
  type: yup.string().required('type is required'),
  sites: yup.array().min(1, 'Please select at least one site'),
  banner: yup.string(),
});
